export default __webpack_public_path__ + "static/media/mc-cormick-x6.3e8da4e4.png";